/**
 * @generated SignedSource<<aa5e2bc153f727a227765414f771440a>>
 * @relayHash 94346eb5747de472f4f68297ebfcf2c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 96dc8b27b8785eeba39db966850e114ceecb3e312d08f02ea4da2d15c8ff2e18

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';
import withDisplayMessage_provider from '@atlassian/jira-relay-provider/src/mbw-191-display-flags-in-case-of-no-columns.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "96dc8b27b8785eeba39db966850e114ceecb3e312d08f02ea4da2d15c8ff2e18",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw191displayflagsincaseofnocolumnsrelayprovider": withDisplayMessage_provider
    }
  }
};

export default node;
